export const mapStyle = {
  "version": 8,
  "name": "Outdoors",
  "metadata": {
      "mapbox:type": "default",
      "mapbox:origin": "outdoors-v12",
      "mapbox:sdk-support": {
          "js": "3.9.0",
          "android": "11.9.0",
          "ios": "11.9.0"
      },
      "mapbox:autocomposite": true,
      "mapbox:groups": {
          "Land & water, land": {
              "name": "Land & water, land",
              "collapsed": true
          },
          "Land & water, water": {
              "name": "Land & water, water",
              "collapsed": true
          },
          "Land & water, built": {
              "name": "Land & water, built",
              "collapsed": true
          },
          "Land & water, terrain-labels": {
              "name": "Land & water, terrain-labels",
              "collapsed": true
          },
          "Place labels, place-labels": {
              "name": "Place labels, place-labels",
              "collapsed": true
          }
      },
      "mapbox:decompiler": {
          "id": "cm6w2ba7i01d801s20aj93i2v",
          "componentVersion": "18.0.0",
          "strata": [
              {
                  "id": "outdoors-v12",
                  "order": [
                      ["land-and-water", "land"],
                      ["land-and-water", "water"],
                      ["land-and-water", "built"],
                      ["land-and-water", "terrain-labels"],
                      ["place-labels", "place-labels"]
                  ]
              }
          ],
          "components": {
              "place-labels": "18.0.0",
              "land-and-water": "18.0.0"
          },
          "propConfig": {
              "place-labels": {
                  "colorBase": "hsl(60, 20%, 85%)",
                  "colorPlaceLabel": "hsl(230, 29%, 25%)",
                  "settlementSubdivisionsDensity": 3
              },
              "land-and-water": {
                  "hillshadeStyle": "Outdoors",
                  "colorEducation": "hsl(40, 45%, 78%)",
                  "landStyle": "Outdoors",
                  "colorGreenspace": "hsl(98, 55%, 70%)",
                  "colorPoi": "hsl(340, 10%, 50%)",
                  "colorPoiParkLike": "hsl(100, 80%, 30%)",
                  "colorAirport": "hsl(230, 40%, 55%)",
                  "colorIndustrialArea": "hsl(230, 20%, 85%)",
                  "colorMedical": "hsl(20, 45%, 82%)",
                  "transitionLandOnZoom": false,
                  "colorBase": "hsl(60, 20%, 85%)",
                  "colorWater": "#262430",
                  "contours": true,
                  "colorCommercialArea": "hsl(55, 45%, 85%)",
                  "bathymetry": true
              }
          }
      },
      "mapbox:thumb": "data:image/png;base64,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",
      "mapbox:uiParadigm": "layers"
  },
  "center": [5.614012495457786, 45.6708809451211],
  "zoom": 3.892806967391535,
  "bearing": 0,
  "pitch": 0,
  "fog": {
      "range": [1, 20],
      "color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          4,
          "hsl(200, 100%, 100%)",
          6,
          "hsl(200, 50%, 90%)"
      ],
      "high-color": [
          "interpolate",
          ["linear"],
          ["zoom"],
          4,
          "hsl(200, 100%, 60%)",
          6,
          "hsl(310, 60%, 80%)"
      ],
      "space-color": [
          "interpolate",
          ["exponential", 1.2],
          ["zoom"],
          4,
          "hsl(205, 10%, 10%)",
          6,
          "hsl(205, 60%, 50%)"
      ],
      "horizon-blend": [
          "interpolate",
          ["exponential", 1.2],
          ["zoom"],
          4,
          0.01,
          6,
          0.1
      ],
      "star-intensity": [
          "interpolate",
          ["exponential", 1.2],
          ["zoom"],
          4,
          0.1,
          6,
          0
      ]
  },
  "sources": {
      "composite": {
          "url": "mapbox://mapbox.mapbox-streets-v8,mapbox.mapbox-terrain-v2,mapbox.mapbox-bathymetry-v2",
          "type": "vector"
      }
  },
  "sprite": "mapbox://sprites/ctotapp/cm6w2ba7i01d801s20aj93i2v/4b5tw4ss3zq1pvvukdq9w44f1",
  "glyphs": "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
  "layers": [
      {
          "id": "land",
          "type": "background",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "layout": {},
          "paint": {"background-color": "hsl(60, 20%, 85%)"}
      },
      {
          "id": "landcover",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "source": "composite",
          "source-layer": "landcover",
          "maxzoom": 12,
          "layout": {},
          "paint": {
              "fill-color": [
                  "match",
                  ["get", "class"],
                  "wood",
                  "hsla(103, 50%, 60%, 0.8)",
                  "scrub",
                  "hsla(98, 47%, 68%, 0.6)",
                  "crop",
                  "hsla(68, 55%, 70%, 0.6)",
                  "grass",
                  "hsla(98, 50%, 74%, 0.6)",
                  "snow",
                  "rgb(106, 106, 106)",
                  "hsl(98, 48%, 67%)"
              ],
              "fill-opacity": [
                  "interpolate",
                  ["exponential", 1.5],
                  ["zoom"],
                  8,
                  0.8,
                  12,
                  0
              ],
              "fill-antialias": false
          }
      },
      {
          "id": "national-park",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "source": "composite",
          "source-layer": "landuse_overlay",
          "minzoom": 5,
          "filter": ["==", ["get", "class"], "national_park"],
          "layout": {},
          "paint": {
              "fill-color": "hsl(98, 38%, 68%)",
              "fill-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  5,
                  0,
                  6,
                  0.6,
                  12,
                  0.2
              ]
          }
      },
      {
          "id": "national-park_tint-band",
          "type": "line",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "source": "composite",
          "source-layer": "landuse_overlay",
          "minzoom": 9,
          "filter": ["==", ["get", "class"], "national_park"],
          "layout": {},
          "paint": {
              "line-color": "hsl(98, 38%, 68%)",
              "line-width": [
                  "interpolate",
                  ["exponential", 1.5],
                  ["zoom"],
                  9,
                  1,
                  14,
                  8
              ],
              "line-blur": [
                  "interpolate",
                  ["exponential", 1.5],
                  ["zoom"],
                  9,
                  1,
                  14,
                  8
              ]
          }
      },
      {
          "id": "landuse",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "source": "composite",
          "source-layer": "landuse",
          "minzoom": 5,
          "filter": [
              "all",
              [">=", ["to-number", ["get", "sizerank"]], 0],
              [
                  "match",
                  ["get", "class"],
                  [
                      "agriculture",
                      "wood",
                      "grass",
                      "scrub",
                      "glacier",
                      "pitch",
                      "sand"
                  ],
                  ["step", ["zoom"], false, 11, true],
                  "residential",
                  ["step", ["zoom"], true, 10, false],
                  ["park", "airport"],
                  [
                      "step",
                      ["zoom"],
                      false,
                      8,
                      ["case", ["==", ["get", "sizerank"], 1], true, false],
                      10,
                      true
                  ],
                  ["facility", "industrial"],
                  ["step", ["zoom"], false, 12, true],
                  "rock",
                  ["step", ["zoom"], false, 11, true],
                  "cemetery",
                  ["step", ["zoom"], false, 11, true],
                  "school",
                  ["step", ["zoom"], false, 11, true],
                  "hospital",
                  ["step", ["zoom"], false, 11, true],
                  "commercial_area",
                  ["step", ["zoom"], false, 11, true],
                  false
              ],
              [
                  "<=",
                  [
                      "-",
                      ["to-number", ["get", "sizerank"]],
                      [
                          "interpolate",
                          ["exponential", 1.5],
                          ["zoom"],
                          12,
                          0,
                          18,
                          14
                      ]
                  ],
                  14
              ]
          ],
          "layout": {},
          "paint": {
              "fill-color": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  15,
                  [
                      "match",
                      ["get", "class"],
                      "wood",
                      "hsla(103, 50%, 60%, 0.8)",
                      "scrub",
                      "hsla(98, 47%, 68%, 0.6)",
                      "agriculture",
                      "hsla(98, 50%, 74%, 0.6)",
                      "park",
                      [
                          "match",
                          ["get", "type"],
                          ["garden", "playground", "zoo"],
                          "hsl(98, 38%, 68%)",
                          "hsl(98, 55%, 70%)"
                      ],
                      "grass",
                      "hsla(98, 50%, 74%, 0.6)",
                      "airport",
                      "hsl(230, 40%, 82%)",
                      "cemetery",
                      "hsl(98, 45%, 75%)",
                      "glacier",
                      "rgb(106, 106, 106)",
                      "hospital",
                      "hsl(20, 45%, 82%)",
                      "pitch",
                      "hsl(88, 65%, 75%)",
                      "sand",
                      "hsl(69, 60%, 72%)",
                      "rock",
                      "hsl(60, 0%, 85%)",
                      "school",
                      "hsl(40, 45%, 78%)",
                      "commercial_area",
                      "hsl(55, 45%, 85%)",
                      "residential",
                      "hsl(60, 7%, 87%)",
                      ["facility", "industrial"],
                      "hsl(230, 20%, 85%)",
                      "hsl(60, 12%, 72%)"
                  ],
                  16,
                  [
                      "match",
                      ["get", "class"],
                      "wood",
                      "hsla(103, 50%, 60%, 0.8)",
                      "scrub",
                      "hsla(98, 47%, 68%, 0.6)",
                      "agriculture",
                      "hsla(98, 50%, 74%, 0.6)",
                      "park",
                      [
                          "match",
                          ["get", "type"],
                          ["garden", "playground", "zoo"],
                          "hsl(98, 38%, 68%)",
                          "hsl(98, 55%, 70%)"
                      ],
                      "grass",
                      "hsla(98, 50%, 74%, 0.6)",
                      "airport",
                      "hsl(230, 40%, 82%)",
                      "cemetery",
                      "hsl(98, 45%, 75%)",
                      "glacier",
                      "rgb(106, 106, 106)",
                      "hospital",
                      "hsl(20, 45%, 82%)",
                      "pitch",
                      "hsl(88, 65%, 75%)",
                      "sand",
                      "hsl(69, 60%, 72%)",
                      "rock",
                      "hsla(60, 0%, 85%, 0.5)",
                      "school",
                      "hsl(40, 45%, 78%)",
                      "commercial_area",
                      "hsla(55, 45%, 85%, 0.5)",
                      ["facility", "industrial"],
                      "hsl(230, 20%, 85%)",
                      "hsl(60, 12%, 72%)"
                  ]
              ],
              "fill-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  8,
                  ["match", ["get", "class"], "residential", 0.8, 0.2],
                  10,
                  ["match", ["get", "class"], "residential", 0, 1]
              ],
              "fill-antialias": false
          }
      },
      {
          "id": "hillshade",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "source": "composite",
          "source-layer": "hillshade",
          "maxzoom": 16,
          "filter": [
              "all",
              [
                  "step",
                  ["zoom"],
                  ["==", ["get", "class"], "shadow"],
                  11,
                  true
              ],
              [
                  "match",
                  ["get", "level"],
                  89,
                  true,
                  78,
                  ["step", ["zoom"], false, 5, true],
                  67,
                  ["step", ["zoom"], false, 9, true],
                  56,
                  ["step", ["zoom"], false, 6, true],
                  94,
                  ["step", ["zoom"], false, 11, true],
                  90,
                  ["step", ["zoom"], false, 12, true],
                  false
              ]
          ],
          "layout": {},
          "paint": {
              "fill-color": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  14,
                  [
                      "match",
                      ["get", "class"],
                      "shadow",
                      "hsla(66, 38%, 17%, 0.08)",
                      "hsla(60, 20%, 95%, 0.14)"
                  ],
                  16,
                  [
                      "match",
                      ["get", "class"],
                      "shadow",
                      "hsla(66, 38%, 17%, 0)",
                      "hsla(60, 20%, 95%, 0)"
                  ]
              ],
              "fill-antialias": false
          }
      },
      {
          "id": "contour-line",
          "type": "line",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "source": "composite",
          "source-layer": "contour",
          "minzoom": 11,
          "filter": ["!=", ["get", "index"], -1],
          "layout": {},
          "paint": {
              "line-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  11,
                  ["match", ["get", "index"], [1, 2], 0.15, 0.3],
                  13,
                  ["match", ["get", "index"], [1, 2], 0.3, 0.5]
              ],
              "line-color": "hsl(60, 10%, 35%)",
              "line-width": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  13,
                  ["match", ["get", "index"], [1, 2], 0.5, 0.6],
                  16,
                  ["match", ["get", "index"], [1, 2], 0.8, 1.2]
              ]
          }
      },
      {
          "id": "cliff",
          "type": "line",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "source": "composite",
          "source-layer": "structure",
          "minzoom": 15,
          "filter": ["==", ["get", "class"], "cliff"],
          "layout": {"line-cap": "round", "line-join": "round"},
          "paint": {
              "line-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  15,
                  0,
                  15.25,
                  1
              ],
              "line-width": 10,
              "line-pattern": "cliff"
          }
      },
      {
          "id": "pitch-outline",
          "type": "line",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, land"
          },
          "source": "composite",
          "source-layer": "landuse",
          "minzoom": 15,
          "filter": ["==", ["get", "class"], "pitch"],
          "layout": {},
          "paint": {"line-color": "hsl(88, 60%, 65%)"}
      },
      {
          "id": "waterway-shadow",
          "type": "line",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, water"
          },
          "source": "composite",
          "source-layer": "waterway",
          "minzoom": 10,
          "layout": {
              "line-cap": ["step", ["zoom"], "butt", 11, "round"],
              "line-join": ["step", ["zoom"], "miter", 11, "round"]
          },
          "paint": {
              "line-color": "rgb(39, 32, 47)",
              "line-width": [
                  "interpolate",
                  ["exponential", 1.3],
                  ["zoom"],
                  9,
                  ["match", ["get", "class"], ["canal", "river"], 0.1, 0],
                  20,
                  ["match", ["get", "class"], ["canal", "river"], 8, 3]
              ],
              "line-translate": [
                  "interpolate",
                  ["exponential", 1.2],
                  ["zoom"],
                  7,
                  ["literal", [0, 0]],
                  16,
                  ["literal", [-1, -1]]
              ],
              "line-translate-anchor": "viewport",
              "line-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  8,
                  0,
                  8.5,
                  1
              ]
          }
      },
      {
          "id": "water-shadow",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, water"
          },
          "source": "composite",
          "source-layer": "water",
          "minzoom": 10,
          "layout": {},
          "paint": {
              "fill-color": "rgb(39, 32, 47)",
              "fill-translate": [
                  "interpolate",
                  ["exponential", 1.2],
                  ["zoom"],
                  7,
                  ["literal", [0, 0]],
                  16,
                  ["literal", [-1, -1]]
              ],
              "fill-translate-anchor": "viewport"
          }
      },
      {
          "id": "waterway",
          "type": "line",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, water"
          },
          "source": "composite",
          "source-layer": "waterway",
          "minzoom": 8,
          "layout": {
              "line-cap": ["step", ["zoom"], "butt", 11, "round"],
              "line-join": ["step", ["zoom"], "miter", 11, "round"]
          },
          "paint": {
              "line-color": "#262430",
              "line-width": [
                  "interpolate",
                  ["exponential", 1.3],
                  ["zoom"],
                  9,
                  ["match", ["get", "class"], ["canal", "river"], 0.1, 0],
                  20,
                  ["match", ["get", "class"], ["canal", "river"], 8, 3]
              ],
              "line-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  8,
                  0,
                  8.5,
                  1
              ]
          }
      },
      {
          "id": "water",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, water"
          },
          "source": "composite",
          "source-layer": "water",
          "layout": {},
          "paint": {"fill-color": "#262430"}
      },
      {
          "id": "water-depth",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, water"
          },
          "source": "composite",
          "source-layer": "depth",
          "maxzoom": 8,
          "layout": {},
          "paint": {
              "fill-antialias": false,
              "fill-color": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  6,
                  [
                      "interpolate",
                      ["linear"],
                      ["get", "min_depth"],
                      0,
                      "rgba(38, 36, 48, 0.35)",
                      200,
                      "rgba(34, 32, 43, 0.35)",
                      7000,
                      "rgba(30, 29, 38, 0.35)"
                  ],
                  8,
                  [
                      "interpolate",
                      ["linear"],
                      ["get", "min_depth"],
                      0,
                      "rgba(38, 36, 48, 0)",
                      200,
                      "rgba(34, 32, 43, 0)",
                      7000,
                      "rgba(28, 27, 36, 0)"
                  ]
              ]
          }
      },
      {
          "id": "wetland",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, water"
          },
          "source": "composite",
          "source-layer": "landuse_overlay",
          "minzoom": 5,
          "filter": [
              "match",
              ["get", "class"],
              ["wetland", "wetland_noveg"],
              true,
              false
          ],
          "paint": {
              "fill-color": "rgb(52, 52, 52)",
              "fill-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  10,
                  0.25,
                  10.5,
                  0.15
              ]
          }
      },
      {
          "id": "wetland-pattern",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, water"
          },
          "source": "composite",
          "source-layer": "landuse_overlay",
          "minzoom": 5,
          "filter": [
              "match",
              ["get", "class"],
              ["wetland", "wetland_noveg"],
              true,
              false
          ],
          "paint": {
              "fill-color": "rgb(52, 52, 52)",
              "fill-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  10,
                  0,
                  10.5,
                  1
              ],
              "fill-pattern": "wetland",
              "fill-translate-anchor": "viewport"
          }
      },
      {
          "id": "land-structure-polygon",
          "type": "fill",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, built"
          },
          "source": "composite",
          "source-layer": "structure",
          "minzoom": 13,
          "filter": [
              "all",
              ["==", ["get", "class"], "land"],
              ["==", ["geometry-type"], "Polygon"]
          ],
          "layout": {},
          "paint": {"fill-color": "hsl(60, 20%, 85%)"}
      },
      {
          "id": "land-structure-line",
          "type": "line",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, built"
          },
          "source": "composite",
          "source-layer": "structure",
          "minzoom": 13,
          "filter": [
              "all",
              ["==", ["get", "class"], "land"],
              ["==", ["geometry-type"], "LineString"]
          ],
          "layout": {"line-cap": "square"},
          "paint": {
              "line-width": [
                  "interpolate",
                  ["exponential", 1.99],
                  ["zoom"],
                  14,
                  0.75,
                  20,
                  40
              ],
              "line-color": "hsl(60, 20%, 85%)"
          }
      },
      {
          "id": "contour-label",
          "type": "symbol",
          "metadata": {
              "mapbox:featureComponent": "land-and-water",
              "mapbox:group": "Land & water, terrain-labels"
          },
          "source": "composite",
          "source-layer": "contour",
          "minzoom": 11,
          "filter": [
              "all",
              [
                  "any",
                  ["==", ["get", "index"], 10],
                  ["==", ["get", "index"], 5]
              ],
              [
                  "step",
                  ["pitch"],
                  true,
                  50,
                  ["<", ["distance-from-center"], 1],
                  60,
                  ["<", ["distance-from-center"], 1.5],
                  70,
                  ["<", ["distance-from-center"], 2]
              ]
          ],
          "layout": {
              "text-field": ["concat", ["get", "ele"], " m"],
              "symbol-placement": "line",
              "text-pitch-alignment": "viewport",
              "text-max-angle": 25,
              "text-padding": 5,
              "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
              "text-size": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  15,
                  9.5,
                  20,
                  12
              ]
          },
          "paint": {
              "text-color": "hsl(60, 10%, 35%)",
              "text-halo-width": 1,
              "text-halo-color": "hsl(60, 10%, 85%)"
          }
      },
      {
          "id": "settlement-subdivision-label",
          "type": "symbol",
          "metadata": {
              "mapbox:featureComponent": "place-labels",
              "mapbox:group": "Place labels, place-labels"
          },
          "source": "composite",
          "source-layer": "place_label",
          "minzoom": 10,
          "maxzoom": 15,
          "filter": [
              "all",
              [
                  "match",
                  ["get", "class"],
                  [
                      "settlement_subdivision",
                      "disputed_settlement_subdivision"
                  ],
                  ["match", ["get", "worldview"], ["all", "US"], true, false],
                  false
              ],
              ["<=", ["get", "filterrank"], 3],
              [
                  "step",
                  ["pitch"],
                  true,
                  50,
                  ["<", ["distance-from-center"], 3],
                  60,
                  ["<", ["distance-from-center"], 4],
                  70,
                  ["<", ["distance-from-center"], 5]
              ]
          ],
          "layout": {
              "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
              "text-transform": "uppercase",
              "text-font": ["DIN Pro Regular", "Arial Unicode MS Regular"],
              "text-letter-spacing": [
                  "match",
                  ["get", "type"],
                  "suburb",
                  0.15,
                  0.05
              ],
              "text-max-width": 7,
              "text-padding": 3,
              "text-size": [
                  "interpolate",
                  ["cubic-bezier", 0.5, 0, 1, 1],
                  ["zoom"],
                  11,
                  ["match", ["get", "type"], "suburb", 11, 10.5],
                  15,
                  ["match", ["get", "type"], "suburb", 15, 14]
              ]
          },
          "paint": {
              "text-halo-color": "hsla(60, 25%, 100%, 0.75)",
              "text-halo-width": 1,
              "text-color": "hsl(230, 29%, 36%)",
              "text-halo-blur": 0.5
          }
      },
      {
          "id": "settlement-minor-label",
          "type": "symbol",
          "metadata": {
              "mapbox:featureComponent": "place-labels",
              "mapbox:group": "Place labels, place-labels"
          },
          "source": "composite",
          "source-layer": "place_label",
          "minzoom": 2,
          "maxzoom": 13,
          "filter": [
              "all",
              ["<=", ["get", "filterrank"], 3],
              [
                  "match",
                  ["get", "class"],
                  ["settlement", "disputed_settlement"],
                  ["match", ["get", "worldview"], ["all", "US"], true, false],
                  false
              ],
              [
                  "step",
                  ["zoom"],
                  [">", ["get", "symbolrank"], 6],
                  4,
                  [">=", ["get", "symbolrank"], 7],
                  6,
                  [">=", ["get", "symbolrank"], 8],
                  7,
                  [">=", ["get", "symbolrank"], 10],
                  10,
                  [">=", ["get", "symbolrank"], 11],
                  11,
                  [">=", ["get", "symbolrank"], 13],
                  12,
                  [">=", ["get", "symbolrank"], 15]
              ],
              [
                  "step",
                  ["pitch"],
                  true,
                  50,
                  ["<", ["distance-from-center"], 3],
                  60,
                  ["<", ["distance-from-center"], 4],
                  70,
                  ["<", ["distance-from-center"], 5]
              ]
          ],
          "layout": {
              "text-line-height": 1.1,
              "text-size": [
                  "interpolate",
                  ["cubic-bezier", 0.2, 0, 0.9, 1],
                  ["zoom"],
                  3,
                  ["step", ["get", "symbolrank"], 11, 9, 10],
                  6,
                  ["step", ["get", "symbolrank"], 14, 9, 12, 12, 10],
                  8,
                  ["step", ["get", "symbolrank"], 16, 9, 14, 12, 12, 15, 10],
                  13,
                  ["step", ["get", "symbolrank"], 22, 9, 20, 12, 16, 15, 14]
              ],
              "text-radial-offset": [
                  "step",
                  ["zoom"],
                  ["match", ["get", "capital"], 2, 0.6, 0.55],
                  8,
                  0
              ],
              "symbol-sort-key": ["get", "symbolrank"],
              "icon-image": [
                  "step",
                  ["zoom"],
                  [
                      "case",
                      ["==", ["get", "capital"], 2],
                      "border-dot-13",
                      [
                          "step",
                          ["get", "symbolrank"],
                          "dot-11",
                          9,
                          "dot-10",
                          11,
                          "dot-9"
                      ]
                  ],
                  8,
                  ""
              ],
              "text-font": ["DIN Pro Regular", "Arial Unicode MS Regular"],
              "text-justify": "auto",
              "text-anchor": [
                  "step",
                  ["zoom"],
                  ["get", "text_anchor"],
                  8,
                  "center"
              ],
              "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
              "text-max-width": 7
          },
          "paint": {
              "text-color": "hsl(230, 29%, 0%)",
              "text-halo-color": "hsl(60, 25%, 100%)",
              "text-halo-width": 1,
              "text-halo-blur": 1
          }
      },
      {
          "id": "settlement-major-label",
          "type": "symbol",
          "metadata": {
              "mapbox:featureComponent": "place-labels",
              "mapbox:group": "Place labels, place-labels"
          },
          "source": "composite",
          "source-layer": "place_label",
          "minzoom": 2,
          "maxzoom": 15,
          "filter": [
              "all",
              ["<=", ["get", "filterrank"], 3],
              [
                  "match",
                  ["get", "class"],
                  ["settlement", "disputed_settlement"],
                  ["match", ["get", "worldview"], ["all", "US"], true, false],
                  false
              ],
              [
                  "step",
                  ["zoom"],
                  false,
                  2,
                  ["<=", ["get", "symbolrank"], 6],
                  4,
                  ["<", ["get", "symbolrank"], 7],
                  6,
                  ["<", ["get", "symbolrank"], 8],
                  7,
                  ["<", ["get", "symbolrank"], 10],
                  10,
                  ["<", ["get", "symbolrank"], 11],
                  11,
                  ["<", ["get", "symbolrank"], 13],
                  12,
                  ["<", ["get", "symbolrank"], 15],
                  13,
                  [">=", ["get", "symbolrank"], 11],
                  14,
                  [">=", ["get", "symbolrank"], 15]
              ],
              [
                  "step",
                  ["pitch"],
                  true,
                  50,
                  ["<", ["distance-from-center"], 3],
                  60,
                  ["<", ["distance-from-center"], 4],
                  70,
                  ["<", ["distance-from-center"], 5]
              ]
          ],
          "layout": {
              "text-line-height": 1.1,
              "text-size": [
                  "interpolate",
                  ["cubic-bezier", 0.2, 0, 0.9, 1],
                  ["zoom"],
                  3,
                  ["step", ["get", "symbolrank"], 13, 6, 11],
                  6,
                  ["step", ["get", "symbolrank"], 18, 6, 16, 7, 14],
                  8,
                  ["step", ["get", "symbolrank"], 20, 9, 16, 10, 14],
                  15,
                  ["step", ["get", "symbolrank"], 24, 9, 20, 12, 16, 15, 14]
              ],
              "text-radial-offset": [
                  "step",
                  ["zoom"],
                  ["match", ["get", "capital"], 2, 0.6, 0.55],
                  8,
                  0
              ],
              "symbol-sort-key": ["get", "symbolrank"],
              "icon-image": [
                  "step",
                  ["zoom"],
                  [
                      "case",
                      ["==", ["get", "capital"], 2],
                      "border-dot-13",
                      [
                          "step",
                          ["get", "symbolrank"],
                          "dot-11",
                          9,
                          "dot-10",
                          11,
                          "dot-9"
                      ]
                  ],
                  8,
                  ""
              ],
              "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
              "text-justify": [
                  "step",
                  ["zoom"],
                  [
                      "match",
                      ["get", "text_anchor"],
                      ["left", "bottom-left", "top-left"],
                      "left",
                      ["right", "bottom-right", "top-right"],
                      "right",
                      "center"
                  ],
                  8,
                  "center"
              ],
              "text-anchor": [
                  "step",
                  ["zoom"],
                  ["get", "text_anchor"],
                  8,
                  "center"
              ],
              "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
              "text-max-width": 7
          },
          "paint": {
              "text-color": "hsl(230, 29%, 0%)",
              "text-halo-color": "hsl(60, 25%, 100%)",
              "text-halo-width": 1,
              "text-halo-blur": 1
          }
      },
      {
          "id": "state-label",
          "type": "symbol",
          "metadata": {
              "mapbox:featureComponent": "place-labels",
              "mapbox:group": "Place labels, place-labels"
          },
          "source": "composite",
          "source-layer": "place_label",
          "minzoom": 3,
          "maxzoom": 9,
          "filter": [
              "all",
              [
                  "match",
                  ["get", "class"],
                  ["state", "disputed_state"],
                  ["match", ["get", "worldview"], ["all", "US"], true, false],
                  false
              ],
              [
                  "step",
                  ["pitch"],
                  true,
                  50,
                  ["<", ["distance-from-center"], 3],
                  60,
                  ["<", ["distance-from-center"], 4],
                  70,
                  ["<", ["distance-from-center"], 5]
              ]
          ],
          "layout": {
              "text-size": [
                  "interpolate",
                  ["cubic-bezier", 0.85, 0.7, 0.65, 1],
                  ["zoom"],
                  4,
                  ["step", ["get", "symbolrank"], 9, 6, 8, 7, 7],
                  9,
                  ["step", ["get", "symbolrank"], 21, 6, 16, 7, 14]
              ],
              "text-transform": "uppercase",
              "text-font": ["DIN Pro Bold", "Arial Unicode MS Bold"],
              "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
              "text-letter-spacing": 0.15,
              "text-max-width": 6
          },
          "paint": {
              "text-color": "hsl(230, 29%, 0%)",
              "text-halo-color": "hsl(60, 25%, 100%)",
              "text-halo-width": 1,
              "text-opacity": 0.5
          }
      },
      {
          "id": "country-label",
          "type": "symbol",
          "metadata": {
              "mapbox:featureComponent": "place-labels",
              "mapbox:group": "Place labels, place-labels"
          },
          "source": "composite",
          "source-layer": "place_label",
          "minzoom": 1,
          "maxzoom": 10,
          "filter": [
              "all",
              [
                  "match",
                  ["get", "class"],
                  ["country", "disputed_country"],
                  ["match", ["get", "worldview"], ["all", "US"], true, false],
                  false
              ],
              [
                  "step",
                  ["pitch"],
                  true,
                  50,
                  ["<", ["distance-from-center"], 3],
                  60,
                  ["<", ["distance-from-center"], 4],
                  70,
                  ["<", ["distance-from-center"], 5]
              ]
          ],
          "layout": {
              "icon-image": "",
              "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
              "text-line-height": 1.1,
              "text-max-width": 6,
              "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
              "text-radial-offset": ["step", ["zoom"], 0.6, 8, 0],
              "text-justify": [
                  "step",
                  ["zoom"],
                  [
                      "match",
                      ["get", "text_anchor"],
                      ["left", "bottom-left", "top-left"],
                      "left",
                      ["right", "bottom-right", "top-right"],
                      "right",
                      "center"
                  ],
                  7,
                  "auto"
              ],
              "text-size": [
                  "interpolate",
                  ["cubic-bezier", 0.2, 0, 0.7, 1],
                  ["zoom"],
                  1,
                  ["step", ["get", "symbolrank"], 11, 4, 9, 5, 8],
                  9,
                  ["step", ["get", "symbolrank"], 22, 4, 19, 5, 17]
              ]
          },
          "paint": {
              "icon-opacity": [
                  "step",
                  ["zoom"],
                  ["case", ["has", "text_anchor"], 1, 0],
                  7,
                  0
              ],
              "text-color": "hsl(230, 29%, 0%)",
              "text-halo-color": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  2,
                  "hsla(60, 25%, 100%, 0.75)",
                  3,
                  "hsl(60, 25%, 100%)"
              ],
              "text-halo-width": 1.25
          }
      },
      {
          "id": "continent-label",
          "type": "symbol",
          "metadata": {
              "mapbox:featureComponent": "place-labels",
              "mapbox:group": "Place labels, place-labels"
          },
          "source": "composite",
          "source-layer": "natural_label",
          "minzoom": 0.75,
          "maxzoom": 3,
          "filter": ["==", ["get", "class"], "continent"],
          "layout": {
              "text-field": ["coalesce", ["get", "name_en"], ["get", "name"]],
              "text-line-height": 1.1,
              "text-max-width": 6,
              "text-font": ["DIN Pro Medium", "Arial Unicode MS Regular"],
              "text-size": [
                  "interpolate",
                  ["exponential", 0.5],
                  ["zoom"],
                  0,
                  10,
                  2.5,
                  15
              ],
              "text-transform": "uppercase",
              "text-letter-spacing": 0.05
          },
          "paint": {
              "text-color": "hsl(230, 29%, 0%)",
              "text-halo-color": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  0,
                  "hsla(60, 25%, 100%, 0.75)",
                  3,
                  "hsl(60, 25%, 100%)"
              ],
              "text-halo-width": 1.5,
              "text-opacity": [
                  "interpolate",
                  ["linear"],
                  ["zoom"],
                  0,
                  0.8,
                  1.5,
                  0.5,
                  2.5,
                  0
              ]
          }
      }
  ],
  "created": "2025-02-08T10:38:27.438Z",
  "modified": "2025-02-08T10:41:27.526Z",
  "id": "cm6w2ba7i01d801s20aj93i2v",
  "owner": "ctotapp",
  "visibility": "private",
  "protected": false,
  "draft": false
}